
import { throwError as observableThrowError,  forkJoin } from 'rxjs';
import { Injectable } from "@angular/core";
import { StreamService } from "./stream.service";
import * as _ from 'lodash';
import { TaxonomyService } from "./taxonomy.service";
import { flatMap } from "rxjs/operators";
import * as X2JS from 'x2js';

@Injectable({ providedIn: 'root' })
export class OpmlImportService {

    constructor(private streamService: StreamService,
                private taxonomyService: TaxonomyService) {}

    parseOpml = (opml) => {
        var x2js = new X2JS();
        const parsedOpml = x2js.xml2js(opml);
        if (!parsedOpml) {
            throw new Error('There was an error parsing the OPML file.');
        }
        return parsedOpml.opml.body.outline;
    }

    crawlOutlines(outline, parentCategory, importData, imgLinks) {
        if (outline.outline) {
            parentCategory = outline._text || outline._title;
            this.crawlOutlines(outline.outline, parentCategory, importData, imgLinks);
        } else if (Array.isArray(outline)) {
            outline.forEach(subOutline => {
                this.crawlOutlines(subOutline, parentCategory, importData, imgLinks);
            });
        } else if (outline._xmlUrl || outline._url) {
            const feed = {
                url: outline._xmlUrl || outline._url,
                title: outline._title || outline._xmlUrl || outline._url,
                category: parentCategory || outline._Category || outline._category,
                description: outline._description || undefined 
            }

            if(outline._img){
                imgLinks.push({
                    sourceUrl: outline._xmlUrl || outline._url,
                    imgUrl: outline._img
                });
            }
            importData.push(feed);
        }
    }

    matchCategory(feed, taxonomy) {
        let matchingCategory;

        if (feed.category) {
            matchingCategory = _.filter(taxonomy, { 'loweredTitle': feed.category.toLowerCase() })[0];
        }

        if (feed.category && !matchingCategory) {
            taxonomy.push({ 'loweredTitle': feed.category.toLowerCase(), 'title': feed.category });
        }
    }

    addMissingCategories(taxonomy, taxonomyVersion) {
        return this.taxonomyService.putTenantTaxonomy(taxonomy, taxonomyVersion);
    }

    importFeed(feed, taxonomy, selectedCategories) {
        const feedData = {
            settings: { uri: feed.url },
            title: feed.title,
            type: 'RSS',
            openForReading: true,
            description: feed.description,
            taxonomicMemberships: undefined
        };
        
        //Associate new categories with streams to be imported
        if (selectedCategories) {
            feedData.taxonomicMemberships = selectedCategories.map((category) => category.id);
        }
        if (feed.category && !feedData.taxonomicMemberships) {
            feedData.taxonomicMemberships = _.map(_.filter(taxonomy, {'title': feed.category}), 'id');
        } else if (feed.category && feedData.taxonomicMemberships) {
            let selectedCategoryIds = _.map(_.filter(taxonomy, {'title': feed.category}), 'id');
            feedData.taxonomicMemberships = feedData.taxonomicMemberships.concat(selectedCategoryIds);
        }

        return this.streamService.saveStream(feedData);
    }

    importOpml(opml, taxonomy, taxonomyVersion, selectedCategories = []) {
        let parsedOpml;
        try {
            parsedOpml = this.parseOpml(opml);
        } catch (err) {
            return observableThrowError(err);
        }

        const importData = [];
        const imgLinks = [];

        this.crawlOutlines(parsedOpml, null, importData, imgLinks);
        taxonomy.forEach((category) => category.loweredTitle = category.title.toLowerCase());
        importData.forEach(feed => this.matchCategory(feed, taxonomy));
        return this.addMissingCategories(taxonomy, taxonomyVersion)
        .pipe(
            flatMap(newTaxonomy => {
                taxonomy = newTaxonomy.data;
                return forkJoin(importData.map(feed => this.importFeed(feed, taxonomy, selectedCategories)));
            }),
            flatMap((streamResponses) => {
                const idMap = {};
                _.forEach(streamResponses, response => {
                    const val = _.result(_.find(imgLinks, { 'sourceUrl': response.settings.uri }), 'imgUrl');
                    if(val){
                        idMap[response.id] = val;
                    }
                });
                return this.streamService.addImages(idMap);
            })
        );
    }
}